import { ControlledDatePicker } from '@@viewCommonComponents/controlled';
import { dateHasConstraints } from '@@viewValidations';
import { birthdateFromAge } from '@@serverHelpers/index.mjs';
import { useEffect } from 'react';
import getExtraLimitsAge from '../../../simulationCustomerGrantees/client/extra/getExtraAgeLimits';

const GranteeBirthDate = ({
  granteeIsChild,
  getFieldsName,
  form,
  disabled,
  getMiddleNumber,
  getMiddleText,
  getMiddleBoolean,
  effectDate,
  ...props
}) => {

  // child
  const minChildAge = getMiddleNumber('BENEFICIAIRE_DATE_NAISSANCE_AGE_MINIMUM_CHILD');
  const maxChildAge = getMiddleNumber('BENEFICIAIRE_DATE_NAISSANCE_AGE_MAXIMUM_CHILD');
  let maxChildBirthDate = null;
  if (minChildAge > -1) {
    maxChildBirthDate = birthdateFromAge(
      minChildAge,
      effectDate,
      getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_TYPE_CALCUL_AGE'),
      false
    );
  }
  let minChildBirthDate = null;
  if (maxChildAge > -1) {
    minChildBirthDate = birthdateFromAge(
      maxChildAge,
      effectDate,
      getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_TYPE_CALCUL_AGE'),
      true
    );
  }

  // spouse
  const { minSpouseAge, maxSpouseAge, spouseAgeInfoText } = getExtraLimitsAge(
    getMiddleNumber,
    getMiddleText
  );

  let maxSpouseBirthDate = null;
  if (minSpouseAge > -1) {
    maxSpouseBirthDate = birthdateFromAge(
      minSpouseAge,
      effectDate,
      getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_TYPE_CALCUL_AGE'),
      false
    );
  }
  let minSpouseBirthDate = null;
  if (maxSpouseAge > -1) {
    minSpouseBirthDate = birthdateFromAge(
      maxSpouseAge,
      effectDate,
      getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_TYPE_CALCUL_AGE'),
      true
    );
  }

  const getRules = (
    isChild,
    minGranteeBirthDate,
    maxGranteeBirthDate,
    minGranteeAge,
    maxGranteeAge
  ) =>
    dateHasConstraints(
      minGranteeBirthDate,
      maxGranteeBirthDate,
      getMiddleText(
        `BENEFICIAIRE_DATE_NAISSANCE_AGE_MINIMUM_${isChild ? 'CHILD' : 'SPOUSE'}_INFO`,
        {
          minGranteeAge
        }
      ),
      getMiddleText(
        `BENEFICIAIRE_DATE_NAISSANCE_AGE_MAXIMUM_${isChild ? 'CHILD' : 'SPOUSE'}_INFO`,
        {
          maxGranteeAge
        }
      ),
      isChild
        ? getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_AGE_CHILD_INFO', {
          minGranteeAge,
          maxGranteeAge
        })
        : spouseAgeInfoText,
      getMiddleBoolean('BENEFICIAIRE_DATE_NAISSANCE_EST_OBLIGATOIRE')
    );

  const rulesSpouse = getRules(
    false,
    minSpouseBirthDate,
    maxSpouseBirthDate,
    minSpouseAge,
    maxSpouseAge
  );
  const rulesChild = getRules(true, minChildBirthDate, maxChildBirthDate, minChildAge, maxChildAge);

  let childToolTipCode = null;

  if (minChildAge > -1 && maxChildAge > -1) {
    childToolTipCode = 'BENEFICIAIRE_DATE_NAISSANCE_AGE_CHILD_INFO';
  } else if (minChildAge > -1) {
    childToolTipCode = 'BENEFICIAIRE_DATE_NAISSANCE_AGE_MINIMUM_CHILD_INFO';
  } else if (maxChildAge > -1) {
    childToolTipCode = 'BENEFICIAIRE_DATE_NAISSANCE_AGE_MAXIMUM_CHILD_INFO';
  }
  const childToolTip = getMiddleText(childToolTipCode, {
    minGranteeAge: minChildAge,
    maxGranteeAge: maxChildAge
  });

  useEffect(() => {
    form.clearErrors(getFieldsName('birthDate'));
    form.trigger(getFieldsName('birthDate'));
  }, [granteeIsChild]);

  return (
    <>
      {granteeIsChild ? (
        <ControlledDatePicker
          name={getFieldsName('birthDate')}
          label={getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_LABEL')}
          tooltip={childToolTip}
          form={form}
          minDate={minChildBirthDate?.toDate()}
          maxDate={maxChildBirthDate?.toDate()}
          rules={rulesChild}
          disabled={disabled}
          {...props}
        />
      ) : (
        <ControlledDatePicker
          name={getFieldsName('birthDate')}
          label={getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_LABEL')}
          form={form}
          minDate={minSpouseBirthDate?.toDate()}
          maxDate={maxSpouseBirthDate?.toDate()}
          rules={rulesSpouse}
          disabled={disabled}
          {...props}
        />
      )}
    </>
  );
};

export default GranteeBirthDate;
